import { format, parseISO } from "date-fns";
import { DATE_AND_TIME_FORMAT } from "utils/date-utils";

export const formatDate = (dateString: string): string => {
  return format(parseISO(dateString), DATE_AND_TIME_FORMAT);
};
